<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <!-- <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col
              cols="12"
              md="9"
              class="d-flex"
              :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : ''"
            >
              <div>
                <v-btn
                  small
                  color="info"
                  class="mr-2"
                  @click="
                    [
                      $router.push({
                        name:
                          'AdministratorOnlineAffiliatesUsersAffiliatesCreate',
                      }),
                      showDialog(),
                    ]
                  "
                >
                  <v-icon small left>mdi-plus</v-icon>
                  {{ $t("newAffiliate") }}
                </v-btn>
              </div>

              <AffiliatesMassImport />

              <div v-if="canLinkExemptPlayerAffiliates">
                <v-btn
                  small
                  color="info"
                  :class="$vuetify.breakpoint.smAndDown ? 'my-2' : 'mx-2'"
                  @click="
                    [
                      $router.push({
                        name:
                          'AdministratorOnlineAffiliatesUsersLinkExemptPlayerAffiliates',
                      }),
                      showDialog(),
                    ]
                  "
                >
                  <v-icon small left>mdi-account-eye</v-icon>
                  {{ $t("linkExemptPlayerBtn") }}
                </v-btn>
              </div>

              <div>
                <v-btn
                  small
                  class="white black--text d-print-none"
                  :class="!$vuetify.breakpoint.smAndDown && 'ml-2'"
                  @click="$printReport()"
                >
                  <v-icon small left>mdi-printer</v-icon>
                  {{ $t("print") }}
                </v-btn>
              </div>

              <v-chip
                v-show="status === 3"
                small
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3 caption' : 'ml-2'"
              >
                {{ $t("legendInactiveAgents") }}
              </v-chip>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div> -->
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          class="elevation-1 mb-3"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:top>
            <div class="pa-3 d-print-none">
              <v-row no-gutters class="align-start">
                <v-col
                  cols="12"
                  md="8"
                  class="d-flex flex-wrap"
                  style="gap: 16px 12px;"
                  >
                  <!-- :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : ''" -->
                  <div>
                    <v-btn
                      
                      color="info"
                      @click="
                        [
                          $router.push({
                            name:
                              'AdministratorOnlineAffiliatesUsersAffiliatesCreate',
                          }),
                          showDialog(),
                        ]
                      "
                    >
                      <v-icon small left>mdi-plus</v-icon>
                      {{ $t("newAffiliate") }}
                    </v-btn>
                  </div>

                  <div>
                    <AffiliatesMassImport />
                  </div>

                  <div v-if="canLinkExemptPlayerAffiliates">
                    <v-btn
                      
                      color="info"
                      @click="
                        [
                          $router.push({
                            name:
                              'AdministratorOnlineAffiliatesUsersLinkExemptPlayerAffiliates',
                          }),
                          showDialog(),
                        ]
                      "
                    >
                      <v-icon small left>mdi-account-eye</v-icon>
                      {{ $t("linkExemptPlayerBtn") }}
                    </v-btn>
                  </div>

                  <div>
                    <!-- :class="!$vuetify.breakpoint.smAndDown && 'ml-2'" -->
                    <v-btn
                      class="white black--text d-print-none"
                      @click="$printReport()"
                    >
                      <v-icon small left>mdi-printer</v-icon>
                      {{ $t("print") }}
                    </v-btn>
                  </div>

                  <v-chip
                    v-show="status === 3"
                    small
                  >
                    {{ $t("legendInactiveAgents") }}
                  </v-chip>
                </v-col>
                <v-col cols="12" md="4" :class="$vuetify.breakpoint.name == 'xs' ? '' : 'd-flex justify-end'">
                  <div>
                    <v-text-field
                      :class="$vuetify.breakpoint.smAndDown ? 'mt-4' : ''"
                      v-model="search"
                      append-icon="mdi-magnify"
                      :label="$t('search')"
                      single-line
                      hide-details
                      dense
                      solo-inverted
                      clearable
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>
          </template>
          <template
            v-for="h in headers"
            v-slot:header.fixedCommissionsSwitch="{ header }"
          >
            <v-tooltip bottom :key="h.value">
              <template v-slot:activator="{ on }">
                <span>
                  {{ header.text }}
                </span>
                <v-icon
                  size="16"
                  color="primary"
                  class="ml-1"
                  v-on="on"
                  style="cursor: pointer;"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div v-html="$t('switchDescription')" />
            </v-tooltip>
          </template>

          <template v-slot:item.id="{ item }">
            <v-btn x-small @click="$copy(item.id)">
              {{ item.id }}
            </v-btn>
          </template>

          <!-- <template v-slot:item.status="{ item }">
            <v-icon :color="handleColorStatus(item.status)" size="16">
              mdi-circle
            </v-icon>
          </template> -->

          <template v-slot:item.name_agent="{ item }">
            <a
              class="blue--text"
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  '/administrator/affiliates/getAffiliate'
                )
              "
            >
              <v-icon color="blue" small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
          </template>

          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_local,
                  '/administrator/affiliates/getLocal'
                )
              "
            >
              <v-icon color="green" small>mdi-account-multiple</v-icon>
              {{ item.name_local }}
            </a>
          </template>

          <template v-slot:item.name_regional="{ item }">
            <a
              class="orange--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_regional,
                  '/administrator/affiliates/getRegional'
                )
              "
            >
              <v-icon color="orange" small>mdi-account-tie</v-icon>
              {{ item.name_regional }}
            </a>
          </template>

          <template v-slot:item.hasInvoice="{ item }">
            <v-switch
              v-model="item.hasInvoice"
              :disabled="item.updatingHasInvoice"
              :loading="item.updatingHasInvoice"
              @change="
                hasInvoiceChanged({
                  affiliate_id: item.id,
                  hasInvoice: item.hasInvoice ? 1 : 0,
                })
              "
            ></v-switch>
          </template>

          <template v-slot:item.fixedCommissionsSwitch="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-switch
                    v-model="item.fixedCommissionsSwitch"
                    :disabled="item.updatingCommission"
                    :loading="item.updatingCommission"
                    @change="
                      comissionTypeChanged({
                        affiliate_id: item.id,
                        commission_type: item.fixedCommissionsSwitch ? 1 : 2,
                      })
                    "
                  ></v-switch>
                </div>
              </template>
              <div v-html="$t('switchDescription')" />
            </v-tooltip>
          </template>

          <template v-slot:item.fixed_comission="{ item }">
            <v-text-field
              v-model="item.comissao_online"
              label="Comissão"
              solo-inverted
              type="number"
              min="0"
              max="99"
              hide-details
              dense
              onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
              :disabled="
                item.updatingCommission || !item.fixedCommissionsSwitch
              "
              :loading="item.updatingCommission"
              @change="
                updateAffiliateCommission({
                  affiliate_id: item.id,
                  commission: Number(item.comissao_online),
                })
              "
              @focus="
                (fixedCommissionFocusedId = item.id),
                  (oldComissionValues[item.id] = Number(item.comissao_online))
              "
              @blur="fixedCommissionFocusedId = 0"
              style="
                width: 90px;
              "
            >
              <v-icon
                slot="prepend-inner"
                size="20"
                :color="fixedCommissionFocusedId == item.id ? 'black' : 'white'"
              >
                mdi-percent
              </v-icon>
            </v-text-field>
          </template>

          <template v-slot:item.fee_value="{ item }">
            <v-text-field
              v-model="item.fee_value"
              :label="$t('value')"
              solo-inverted
              type="number"
              min="0"
              max="99"
              hide-details
              dense
              onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
              :disabled="item.updatingTax"
              :loading="item.updatingTax"
              @change="
                updateAffiliateTax({
                  affiliate_id: item.id,
                  fee_value: Number(item.fee_value),
                })
              "
              @focus="
                (taxFocusedId = item.id),
                  (oldFeeValues[item.id] = Number(item.fee_value))
              "
              @blur="taxFocusedId = 0"
              style="width: 90px;"
            >
              <v-icon
                slot="prepend-inner"
                size="20"
                :color="taxFocusedId == item.id ? 'black' : 'white'"
              >
                mdi-percent
              </v-icon>
            </v-text-field>
          </template>

          <!-- <template v-slot:item.data_cadastro="{ item }">
            <span class="caption">{{ item.data_cadastro }}</span>
          </template> -->

          <template v-slot:item.cpa_type="{ item }">
            <div class="d-flex align-center">
              <div>
                {{ handleCpaType(item.cpa_type) }}
              </div>
            </div>
          </template>

          <template v-slot:item.cpa_value="{ item }">
            <div class="d-flex">
              <div>
                {{ item.cpa_value }}
              </div>
            </div>
          </template>

          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-tooltip top v-if="!hideViewBets">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    v-on:click="
                      $router.push({
                        name: 'AdministratorBetListPlayerOnline',
                        query: {
                          id_regional: item.id_regional,
                          id_local: item.id_local,
                          id_agent: item.id,
                        },
                      })
                    "
                  >
                    <v-icon>mdi-ticket-confirmation</v-icon>
                  </v-btn>
                </template>
                <span> {{ $t("viewBets") }} </span>
              </v-tooltip>
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="rounded"
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      $profile.showProfileDrawer(
                        item.id,
                        '/administrator/affiliates/getAffiliate'
                      )
                    "
                  >
                    <v-icon>mdi-account</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("profile") }} </span>
              </v-tooltip> -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="rounded"
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name:
                            'AdministratorOnlineAffiliatesUsersAffiliatesEdit',
                          params: { id: item.id },
                        }),
                        showDialog(),
                      ]
                    "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("edit") }} </span>
              </v-tooltip>
              <!-- <v-tooltip top> 
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="$copy(item.affiliateLink)"
                  >
                    <v-icon>mdi-link</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("copyAffiliateLink") }}</span>
              </v-tooltip> -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name:
                            'AdministratorOnlineAffiliatesUsersAffiliatesAnalyticalReport',
                          params: {
                            id: item.id,
                            name: item.name_agent,
                            status: item.status,
                          },
                        }),
                        showDialog(),
                      ]
                    "
                  >
                    <v-icon>mdi-chart-line</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("analyticReport") }}</span>
              </v-tooltip>
              <v-tooltip
                v-if="canLinkExemptPlayerAffiliates && status === 1"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name:
                            'AdministratorOnlineAffiliatesUsersLinkAffiliateExemptPlayer',
                          params: { id: item.id },
                        }),
                        showDialog(item),
                      ]
                    "
                  >
                    <v-icon>mdi-account-eye</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("linkAffiliateExemptPlayerBtn") }}</span>
              </v-tooltip>

              <div class="tooltip d-flex justify-center">
                <Adhesions
                  parent="affiliates"
                  :affiliateId="item.id"
                  :showSeeGames="false"
                />
                <span class="tooltipText body-2">{{ $t("usersByCampaign") }}</span>
              </div>

              <MenuDropdownStatusUser
                :id_user="item.id"
                :status_user="item.status"
              />
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import MenuDropdownStatusUser from "@/components/administrator/menu/dropdownStatusUser.vue";
import HeaderPrint from "@/components/common/header-print";
import hasFeeValue from "@/util/hasFeeValue";
import Adhesions from "@/components/common/adhesions";
import AffiliatesMassImport from "./AffiliatesMassImport.vue";

export default {
  components: {
    MenuDropdownStatusUser,
    HeaderPrint,
    Adhesions,
    AffiliatesMassImport
},
  name: "administrator-users-agents-list",
  data: () => ({
    data: [],
    search: "",
    hideViewBets: false,
    beingUpdated: {},
    commissionTypes: {
      FIXED: 1,
      VARIABLE: 2,
    },
    oldComissionValues: {},
    fixedCommissionFocusedId: 0,
    oldFeeValues: {},
    taxFocusedId: 0,
  }),
  mounted() {
    this.hideViewBets =
      this.$route.name === "AdministratorAffiliatesAffiliatesList" ||
      this.$route.name ===
        "AdministratorOnlineAffiliatesUsersAffiliatesAnalyticalReport";
  },
  computed: {
    canLinkExemptPlayerAffiliates() {
      return this.$hasExemptPlayer();
    },
    hasFeeValue() {
      return hasFeeValue;
    },
    // =================================================== //
    // Translate
    // =================================================== //
    headers() {
      const headers = [
        { text: "Id", value: "id" },
        // {  {text: this.$t("status"), value: "status" },
        { text: this.$t("name"), value: "name_agent" },
        { text: this.$t("login"), value: "login_agent" },
        { text: this.$t("mLocal"), value: "name_local" },
        { text: this.$t("mRegional"), value: "name_regional" },
        {
          text: this.$t("payments.withInvoice"),
          value: "hasInvoice",
          sortable: false,
        },
        {
          text: this.$t("fixedCommission"),
          value: "fixedCommissionsSwitch",
          sortable: false,
        },
        {
          text: this.$t("commissionValue"),
          value: "fixed_comission",
          sortable: false,
        },
        ...(this.hasFeeValue
          ? [
              {
                text: this.$t("feeValue"),
                value: "fee_value",
                align: "center",
                sortable: false,
              },
            ]
          : []),
        // { text: this.$t("createdIn"), value: "data_cadastro" },
      ];

      const showCpa = true;

      if (showCpa) {
        headers.push(
          {
            text: this.$t("cpaType"),
            value: "cpa_type",
          },
          {
            text: this.$t("cpaValue"),
            value: "cpa_value",
          }
        );
      }

      headers.push({
        text: this.$t("actions"),
        value: "action",
        align: "center d-print-none",
        sortable: false,
      });

      return headers;
    },
    //
    // ====================================================
    // 2. Retrieve Values in Filters
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    // ====================================================
    // Retrieve Range (ONLY - AGENTS INACTIVES)
    rangeDate() {
      return this.$store.state.range.date;
    },

    qtd_bet() {
      return this.$store.state.filters.quantityBet.value;
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    hasInvoice() {
      return this.$store.state.filters.hasInvoice.value;
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    btnClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'mb-4' : 'mr-3'
    }
  },
  watch: {
    // breakpoint(val) {
    //   console.log(val)
    // },
    saveFilters(val) {
      val && this.getAgentsList();
    },
    refresh(val) {
      val && this.getAgentsList();
      this.$store.commit("setRefresh", false);
    },
  },
  methods: {
    resetPage() {
      this.search = "";
    },
    async getAgentsList() {
      this.resetPage();

      // common
      const body = {
        id_regional: this.id_regional,
        id_local: this.id_local,
        status: this.status,
        invoice: this.hasInvoice,
      };

      let endpoint = "/administrator/affiliates/listAffiliates";

      const response = await this.$request.post(endpoint, body);

      this.data = response.length == 0 ? [] : response.dados;
      this.data = this.data.map((item) => {
        item.data_cadastro = new Date(
          item.data_cadastro.replace(" ", "T")
        ).toLocaleString();

        let operatorUrl = this.$operator.url;
        if (operatorUrl.slice(-1) == "/") {
          operatorUrl = operatorUrl.slice(0, -1);
        }

        const affiliateCode = this.parseIdToAffiliateCode(item.id);
        const affiliateLink = `${operatorUrl}/player-from-agent/agent/${affiliateCode}`;

        const fixedCommission = Number(item.comissao_online);

        if (Number.isInteger(fixedCommission)) {
          item.comissao_online = parseInt(fixedCommission);
        }

        const feeValue = Number(item.fee_value);

        if (Number.isInteger(feeValue)) {
          item.fee_value = parseInt(feeValue);
        }

        return {
          ...item,
          affiliateLink,
          fixedCommissionsSwitch:
            item.commission_type == this.commissionTypes.FIXED,
          updatingCommission: false,
          hasInvoice: item.invoice === "1",
          updatingHasInvoice: false,
        };
      });
    },

    hasInvoiceChanged({ affiliate_id, hasInvoice }) {
      const affiliate = this.data.find(
        (affiliate) => affiliate.id == affiliate_id
      );

      if (affiliate && affiliate.updatingHasInvoice) {
        return;
      }

      this.setUpdatingHasInvoice({ affiliate_id, updatingHasInvoice: true });

      this.$axios
        .post(
          "/administrator/affiliates/setAffiliateInvoice",
          this.$formdata({ affiliate_id, invoice: hasInvoice })
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("setFeedbackSnack", {
            msg: err.response.data.messages?.error || err.response.statusText,
            color: "warning",
          });

          this.data = this.data.map((affiliate) => {
            if (affiliate.id == affiliate_id) {
              return {
                ...affiliate,
                hasInvoice: !affiliate.hasInvoice,
              };
            }

            return affiliate;
          });
        })
        .finally(() => {
          this.setUpdatingHasInvoice({
            affiliate_id,
            updatingHasInvoice: false,
          });
        });
    },

    parseIdToAffiliateCode(id) {
      return parseInt(id, +"", 10).toString(36);
    },

    // Show Dialog
    showDialog(affiliateData) {
      this.$store.commit("showDialog", true);

      // Config inicial da Dialog de vincular jogador isento a um afiliado
      // Se o afiliado tiver um jogador isento vinculado
      if (affiliateData && affiliateData.exempt_player_id) {
        this.$store.commit("setLinkedExemptPlayer", {
          alreadyLinked: true,
          id: affiliateData.exempt_player_id,
          name: affiliateData.exempt_player_name,
        });
      }
    },
    // handle color status
    handleColorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },

    comissionTypeChanged({ affiliate_id, commission_type }) {
      const affiliate = this.data.find(
        (affiliate) => affiliate.id == affiliate_id
      );

      if (affiliate && affiliate.updatingCommission) {
        return;
      }

      this.setUpdatingCommission({ affiliate_id, updatingCommission: true });

      this.$axios
        .post(
          "/administrator/affiliates/changeAffiliateCommissionType",
          this.$formdata({ affiliate_id, commission_type })
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("setFeedbackSnack", {
            msg: err.response.data.messages.error,
            color: "warning",
          });

          this.data = this.data.map((affiliate) => {
            if (affiliate.id == affiliate_id) {
              return {
                ...affiliate,
                fixedCommissionsSwitch: !affiliate.fixedCommissionsSwitch,
              };
            }

            return affiliate;
          });
        })
        .finally(() => {
          this.setUpdatingCommission({
            affiliate_id,
            updatingCommission: false,
          });
        });
    },

    updateAffiliateCommission({ affiliate_id, commission }) {
      if (!Number.isInteger(commission)) {
        this.returnCommissionValue({
          affiliate_id,
          commission: this.oldComissionValues[affiliate_id],
        });

        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("commissionsOnlyInteger"),
          color: "warning",
        });

        return;
      }

      if (commission >= 100) {
        this.returnCommissionValue({
          affiliate_id,
          commission: this.oldComissionValues[affiliate_id],
        });

        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("commissionEqualOrGreaterThan100"),
          color: "warning",
        });

        return;
      }

      const affiliate = this.data.find(
        (affiliate) => affiliate.id == affiliate_id
      );

      if (affiliate && affiliate.updatingCommission) {
        return;
      }

      this.setUpdatingCommission({
        affiliate_id,
        updatingCommission: true,
      });

      this.$axios
        .post(
          "/administrator/affiliates/updateAffiliateCommission",
          this.$formdata({
            affiliate_id: affiliate_id,
            commission: commission ? commission : 0,
          })
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((err) => {
          this.returnCommissionValue({
            affiliate_id,
            commission: this.oldComissionValues[affiliate_id],
          });

          this.$store.commit("setFeedbackSnack", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.setUpdatingCommission({
            affiliate_id,
            updatingCommission: false,
          });
        });
    },

    updateAffiliateTax({ affiliate_id, fee_value }) {
      if (!Number.isInteger(fee_value)) {
        this.returnTaxValue({
          affiliate_id,
          fee_value: this.oldFeeValues[affiliate_id],
        });

        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("feeValueOnlyInteger"),
          color: "warning",
        });

        return;
      }

      if (fee_value >= 100) {
        this.returnTaxValue({
          affiliate_id,
          fee_value: this.oldFeeValues[affiliate_id],
        });

        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("feeValueEqualOrGreaterThan100"),
          color: "warning",
        });

        return;
      }

      const affiliate = this.data.find(
        (affiliate) => affiliate.id == affiliate_id
      );

      if (affiliate && affiliate.updatingTax) {
        return;
      }

      this.setUpdatingTax({
        affiliate_id,
        updatingTax: true,
      });

      this.$axios
        .post(
          "/administrator/affiliates/updateAffiliateFee",
          this.$formdata({
            affiliate_id: affiliate_id,
            fee_value: fee_value ? fee_value : 0,
          })
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((err) => {
          this.returnTaxValue({
            affiliate_id,
            fee_value: this.oldFeeValues[affiliate_id],
          });

          this.$store.commit("setFeedbackSnack", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.setUpdatingTax({
            affiliate_id,
            updatingTax: false,
          });
        });
    },

    setUpdatingCommission({ affiliate_id, updatingCommission }) {
      this.data = this.data.map((affiliate) => {
        if (affiliate.id == affiliate_id) {
          return { ...affiliate, updatingCommission };
        }

        return affiliate;
      });
    },

    setUpdatingHasInvoice({ affiliate_id, updatingHasInvoice }) {
      this.data = this.data.map((affiliate) => {
        if (affiliate.id == affiliate_id) {
          return { ...affiliate, updatingHasInvoice };
        }

        return affiliate;
      });
    },

    setUpdatingTax({ affiliate_id, updatingTax }) {
      this.data = this.data.map((affiliate) => {
        if (affiliate.id == affiliate_id) {
          return { ...affiliate, updatingTax };
        }

        return affiliate;
      });
    },

    returnCommissionValue({ affiliate_id, commission }) {
      this.data = this.data.map((affiliate) => {
        if (affiliate.id == affiliate_id) {
          return {
            ...affiliate,
            comissao_online: commission,
          };
        }

        return affiliate;
      });
    },

    returnTaxValue({ affiliate_id, fee_value }) {
      this.data = this.data.map((affiliate) => {
        if (affiliate.id == affiliate_id) {
          return {
            ...affiliate,
            fee_value,
          };
        }

        return affiliate;
      });
    },

    handleCpaType(type) {
      if (type == 0) {
        return this.$t("disabled");
      }
      if (type == 1) {
        return `${this.$t("fixedRate")} (${this.$t("labelCurrency")})`;
      }
      if (type == 2) {
        return `${this.$t("percent")} (%)`;
      }
    },

    // openVariableCommissionsDialog() {
    //   this.$root.$emit("openVariableCommissions");
    // },
  },
};
</script>

<style scoped>
/* .btnClass {
  margin-right: 12px;
} */
.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip .tooltipText {
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 30px;
  margin: auto;
  background-color: rgb(100, 100, 100);
  color: rgb(228, 228, 228);
  
  border-radius: 4px;
  padding: 4px 8px;
  bottom: 40px;
  right: -10%;
  hyphens: auto;
  word-break: normal;

  opacity: 0;
  transition: opacity 0.3s;

  /* Position the tooltip */
  position: absolute;
  z-index: 10;
}

.tooltip:hover .tooltipText {
  visibility: visible;
  opacity: 1;
}
</style>
